/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
  CmpTypographyField,
  CmpInputField,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useLocation, useNavigate } from "react-router-dom";
import DeliveryDetailModal from "./Component/DeliveryDetailModal";
import { DeliveryItemListTblCard } from "./Component/DeliveryItemListTblCard";
import {
  Delivery_ItemList_Delete,
  Delivery_ItemList_Save,
  Delivery_ItemList_load,
  Get_Delivery_ItemList,
} from "../../Server/ApiV2";
import { DeliveryList_Set } from "./SliceDelivery";
import { useDispatch, useSelector } from "react-redux";
import Delivery_BreadCrumbs from "./Delivery_BreadCrumbs";
import { DeliveryItemListDetailTblCard } from "./Component/DeliveryItemListDetailTblCard";
import { Typography } from "@mui/material";
import { fAlertToast } from "../../Utility/Utilitys";

export default function DeliveryItemDetail() {
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const navigate = useNavigate();
  const vRdxDelivery = useSelector(
    (state) => state.SliceDelivery.value.HeadObj
  );
  const vRdxDeliveryDetail = useSelector(
    (state) => state.SliceDelivery.value.DetailObj
  );
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });
  const [sDeliverItemListData, setDeliverItemListData] = useState([]);
  const [sDeliverItemListObj, setDeliverItemListObj] = useState({
    SrNo: 0,
    SerialNo: "",
  });

  const Detail_Grid_columns = [
    {
      field: "RowId",
      headerName: "RowId",
      width: 80,
      hide: true,
    },
    {
      field: "ID",
      headerName: "Sr.No",
      width: 80,
    },
    {
      field: "SerialNo",
      headerName: "Serial.No",
      width: 100,
    },
  ];

  const fOnChange = (e) => {
    setDeliverItemListObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fNew = async () => {
    setDeliverItemListObj({
      SrNo: 0,
      SerialNo: "",
    });
  }
  const loadItemList = async () => {
    const req = await Delivery_ItemList_load({
      VocTyp: vRdxDelivery.VocTyp,
      VocNo: vRdxDelivery.VocNo,
      SrNo: vRdxDeliveryDetail.SrNo,
      ItmCd: vRdxDeliveryDetail.ItmCd,
    });

    if (req?.status === 200) { 
      
      const loadedData =req.data.ResultSet.length==0?[]: req.data.ResultSet.map((item, index) => ({
        ...item,
        id: index + 1,
      }));
      setDeliverItemListData(loadedData);
      return loadedData
    }else{
      return []
    }
  };

  const deleteItemList = async () => {
    const req = await Delivery_ItemList_Delete({
      VocTyp: vRdxDelivery.VocTyp,
      VocNo: vRdxDelivery.VocNo,
      SrNo: vRdxDeliveryDetail.SrNo,
      ItmCd: vRdxDeliveryDetail.ItmCd,
      RowId: sDeliverItemListObj.SrNo,
    });

    if (req?.status === 200) {
      fNew();
      loadItemList();
    }
  };
  const saveItemList = async () => {
    if (sDeliverItemListObj.SerialNo == "") {
      fAlertToast("FAILED", "SerialNo should not be empty");
      return;
    } else if (vRdxDelivery.DeliveryStatus != "ENTER") {
      fAlertToast(
        "FAILED",
        `Item not allowed to save in ${vRdxDelivery.DeliveryStatus}`
      );
      return;
    } else if (
      sDeliverItemListData.length == vRdxDeliveryDetail.Qty &&
      sDeliverItemListObj.SrNo == 0
    ) {
      fAlertToast("FAILED", `Not allowed to save ,Quantity exceed`);
      return;
    } else if (sDeliverItemListData.length > vRdxDeliveryDetail.Qty) {
      fAlertToast("FAILED", `Quantity exceed`);
      return;
    } else if( sDeliverItemListObj.SrNo == 0 && sDeliverItemListData.find(item => sDeliverItemListObj.SerialNo == item.SerialNo )  ){
      
      fAlertToast("FAILED", `SerialNo already exist`);
      return;
    }else if( sDeliverItemListObj.SrNo != 0 && sDeliverItemListData.find(item => sDeliverItemListObj.SrNo != item.RowId &&sDeliverItemListObj.SerialNo == item.SerialNo ) ){
      
      fAlertToast("FAILED", `SerialNo already exist`);
      return;
    }else{
      const req = await Delivery_ItemList_Save({
        VocTyp: vRdxDelivery.VocTyp,
        VocNo: vRdxDelivery.VocNo,
        SrNo: vRdxDeliveryDetail.SrNo,
        ItmCd: vRdxDeliveryDetail.ItmCd,
        SerialNo: sDeliverItemListObj.SerialNo,
        RowId: sDeliverItemListObj.SrNo,
      });

      if (req?.status === 200) {
        // If save is successful, load the data again
       
        fNew()

        let gridArr=loadItemList();
      
        console.log("gridArr",gridArr);
        console.log(gridArr.length == vRdxDeliveryDetail.Qty,gridArr.length , vRdxDeliveryDetail.Qty);
        
        if(gridArr.length == vRdxDeliveryDetail.Qty){
          
          navigate("/deliveryDetail");
        }
      }
    }
  };

  useEffect(() => {
    loadItemList();
  }, []);

  return (
    <div className="container-fluid my-1">
      <div className=" mb-2">
        <Delivery_BreadCrumbs />
      </div>
      <div className="Instant-picking-head">
        {/* label  */}
        <Grid container spacing={{ xs: 0, sm: 0, md: 1.5   }}>
          <Grid item   md={"auto"} xs={3.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={"BarCode  "  }
            />
          </Grid>
          <Grid item   md={0.3} xs={0.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={" : "  }
            />
          </Grid>
          <Grid item   md={2} xs={8}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={ vRdxDeliveryDetail.BarCode}
            />
          </Grid>
          <Grid item   md={'auto'} xs={3.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={"Ref.No  " }
            />
          </Grid>
          <Grid item   md={0.3} xs={0.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={" : "  }
            />
          </Grid>
          <Grid item   md={'auto'} xs={8}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={ vRdxDeliveryDetail.SuppRefNo1}
            />
          </Grid>
          <Grid item   md={'auto'} xs={3.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={"Qty  "  }
            />
          </Grid>
          <Grid item   md={0.3} xs={0.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={" : "  }
            />
          </Grid>
          <Grid item   md={'auto'} xs={8}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={vRdxDeliveryDetail.Qty}
            />
          </Grid>
          <Grid item   md={'auto'} xs={3.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={"RefDocNo "  }
            />
          </Grid>
          <Grid item   md={0.3} xs={0.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={" : "  }
            />
          </Grid>
          <Grid item   md={'auto'} xs={8}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={vRdxDelivery.RefDocNo}
            />
          </Grid>
          
        </Grid>
        <Grid container spacing={{ xs: 0, sm: 0, md: 1 }}>
        <Grid item   md={"auto"} xs={3.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={"Item Name  " }
            />
          </Grid>
          <Grid item   md={0.3} xs={0.5}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={" : "  }
            />
          </Grid>
          <Grid item   md={"auto"} xs={8}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={  vRdxDeliveryDetail.ItmName}
            />
          </Grid>
        </Grid>
        <Grid
          container
          columnSpacing={1}
          rowSpacing={2}
          columns={{ xs: 12, sm: 12, md: 12 }}
          className="mt-1"
          alignItems={"center"}
        >
          <Grid item xs={3} sm={3.5} md={2}>
            <CmpTypographyField
              xcomponent={"span"}
              xfontSize={vMediaQuery? "14px": "20px"}
              xText={"Serial No"}
            />
          </Grid>

          <Grid item xs={9} sm={8} md={4}>
            <CmpInputField
              xType={"text"} // text/number/password
              xName={"SerialNo"}
              xValue={sDeliverItemListObj.SerialNo}
              xReadOnly={false}
              xOnChange={fOnChange}
              xOnKeyUp={(e) => {
                if (e.key === "Enter") {
                  saveItemList(e);
                }
              }}
            />
          </Grid>
          <Grid item xs={4} md={"auto"}>
            <CmpButton
              xbtnName="New"
              xOnClick={() => {
                fNew()
              }}
              xVariant="contained"
              xSize="small"
            />
          </Grid>
          <Grid item xs={4} md={"auto"}>
            <CmpButton
              xbtnName="Save"
              xOnClick={saveItemList}
              xVariant="contained"
              xSize="small"
              xDisabled={vRdxDelivery.DeliveryStatus != "ENTER"}
            />
          </Grid>
          <Grid item xs={4} md={"auto"}>
            <CmpButton
              xbtnName="Delete"
              xOnClick={deleteItemList}
              xVariant="contained"
              xSize="small"
              xDisabled={vRdxDelivery.DeliveryStatus != "ENTER"}
            />
          </Grid>
        </Grid>

        <Grid container spacing={1} className="search-item pt-4">
          <Grid item xs={12} className=" height-table-scroll" component="div">
            <div
              style={{
                height: vMediaQuery ? "40vh" : "45vh",
                width: "100%",
              }}
              id="table-main-grid-3"
              className="search-grid-table mt-2"
            >
              <Box style={{ height: "100%", width: "100%" }}>
                <DataGrid
                  rowHeight={30}
                  headerHeight={40}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0
                      ? "mui-even-row"
                      : "mui-odd-row"
                  }
                  sx={{
                    border: 1,
                    borderColor: "primary.light",
                  }}
                  rows={sDeliverItemListData}
                  columns={Detail_Grid_columns}
                  getRowId={(row) => row.id}
                  hideFooter={sDeliverItemListData?.length < 100}
                  onRowClick={(item) => {
                    setDeliverItemListObj({
                      SrNo: item.row.RowId,
                      SerialNo: item.row.SerialNo,
                    });
                  }}
                  // components={{
                  //   Toolbar: GridToolbar,
                  // }}
                />
              </Box>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
